import React,{useState} from 'react'
import '../Price/Price.css'
import Icard from '../Icard/Icard';
const Price = () => {
  const [isIcardOpen, setIsIcardOpen] = useState(false);

    const openIcard = () => {
        setIsIcardOpen(true);
      };
    
      const closeIcard = () => {
        setIsIcardOpen(false);
      };
  return (
    <>
      <section className="price-section">
      {isIcardOpen && <Icard onClose={closeIcard} />}
  {/* Left Column */}
  <div className="left-p">
    <h2 className="price-heading">Affordable Pricing</h2>
    <p className="price-subheading">Choose the property that suits your needs and enjoy exceptional quality at great prices</p>
  </div>
  {/* Right Column */}
  <div className="right-p">
   
    <table className="price-table">
      <thead>
        <tr>
          <th>Types of Unit</th>
          <th>Area</th>
          <th>Prices</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>3 BHK + Servant </td>
          <td>Area (2452) SQ.FT. (Mivan Constructions)</td>
          <td className="price-highlight" onClick={openIcard}>Enquire Now</td>
        </tr>
        <tr>
          <td>3 BHK + Servant </td>
          <td>Area (2165) SQ.FT. (Mivan Constructions)</td>
          <td className="price-highlight" onClick={openIcard}>Enquire Now</td>
        </tr>
      
      </tbody>
    </table>
   
  </div>
</section>



    </>
  )
}

export default Price